import styled, { css } from 'styled-components';

export const SkipToContentLink = styled.a`
  position: fixed;
  top: -40px;
  left: 12px;
  padding: 12px 10px;
  z-index: 100;
  text-decoration: underline;
  transition: top 0.3s;
  ${({ theme }) => css`
    background-color: ${theme.colors.black};
    color: ${theme.colors.white};
  `}

  &:focus {
    top: 69px;
  }
`;
